import React from 'react';
import CollapsibleBox from './CollapsibleBox';
import MakeOfferForm from './MakeOfferForm';
import OffersTable from './OffersTable';
import GameInstancesTable from './GameInstancesTable';
import './GameMaker.css';

/**
 * GeneralSection Component
 * 
 * Contains the three general boxes that are always visible with editable filters:
 * A0) Game instances (with advanced filtering)
 * B0) Offers (with advanced filtering) 
 * C) Offer templates (current MakeOfferForm)
 * 
 * These boxes always show regardless of content and have user-configurable filters
 * that default to showing all active items.
 */
const GeneralSection = ({
  // All props needed for the three main components
  // MakeOfferForm props
  queriedGames,
  setQueriedGames,
  GameRegistryConfig,
  GameRegistryContractAddress,
  provider,
  signer,
  ethersUtils,
  createContract,
  makeOffer,
  gameUrls,
  setGameUrls,
  validateNetwork,
  validateSigner,

  // Action handlers
  acceptOffer,
  killGame,
  offerDraw,
  acceptDrawOffer,
  withdrawDrawOffer,

  // Shared props
  playerAccount,
  games
}) => {
  return (
    <div className="general-section">
      <div className="section-header">
        <h2 className="section-title">General</h2>
        <p className="section-subtitle">
          Browse all offers and games with customizable filters
        </p>
      </div>

      <div className="grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {/* C) Offer Templates - Always visible */}
        <div className="lg:col-span-1">
          <CollapsibleBox
            title="Create New Offer"
            subtitle="Choose a game and set your terms"
            priority="info"
            storageKey="general_offer_templates"
            className="h-fit"
            sectionId="create-offer"
          >
            <MakeOfferForm
              queriedGames={queriedGames}
              setQueriedGames={setQueriedGames}
              GameRegistryConfig={GameRegistryConfig}
              GameRegistryContractAddress={GameRegistryContractAddress}
              provider={provider}
              signer={signer}
              ethersUtils={ethersUtils}
              createContract={createContract}
              makeOffer={makeOffer}
              gameUrls={gameUrls}
              setGameUrls={setGameUrls}
              validateNetwork={validateNetwork}
              validateSigner={validateSigner}
              // Remove the collapsible wrapper from MakeOfferForm itself
              hideWrapper={true}
            />
          </CollapsibleBox>
        </div>

        {/* B0) Offers - Always visible with advanced filtering */}
        <div className="lg:col-span-1">
          <CollapsibleBox
            title="Browse Offers"
            subtitle="All available game offers"
            priority="purple"
            storageKey="general_offers"
            className="h-fit"
            sectionId="browse-offers"
          >
            <OffersTable
              ethersUtils={ethersUtils}
              acceptOffer={acceptOffer}
              killGame={killGame}
              playerAccount={playerAccount}
              games={games}
              // Remove the collapsible wrapper from OffersTable itself
              hideWrapper={true}
            />
          </CollapsibleBox>
        </div>

        {/* A0) Game Instances - Always visible with advanced filtering */}
        <div className="lg:col-span-1">
          <CollapsibleBox
            title="Browse Games" 
            subtitle="All active and completed games"
            priority="red-light"
            storageKey="general_game_instances"
            className="h-fit"
            sectionId="browse-games"
          >
            <GameInstancesTable
              games={games}
              playerAccount={playerAccount}
              killGame={killGame}
              offerDraw={offerDraw}
              acceptDrawOffer={acceptDrawOffer}
              withdrawDrawOffer={withdrawDrawOffer}
              gameUrls={gameUrls}
              ethersUtils={ethersUtils}
              // Remove the collapsible wrapper from GameInstancesTable itself
              hideWrapper={true}
            />
          </CollapsibleBox>
        </div>
      </div>
    </div>
  );
};

export default GeneralSection;